export default __webpack_public_path__ + "static/media/drinks.c69b1f97.png";